import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=b8d0e1e0"
import script from "./Servers.vue?vue&type=script&lang=js"
export * from "./Servers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports